import { render, staticRenderFns } from "./AnnTableDialog.vue?vue&type=template&id=ab20d448&scoped=true&"
import script from "./AnnTableDialog.vue?vue&type=script&lang=js&"
export * from "./AnnTableDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnTableDialog.vue?vue&type=style&index=0&id=ab20d448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab20d448",
  null
  
)

export default component.exports